import { createFileRoute } from "@tanstack/react-router";
import { UnstakePage } from "../../features/staking/pages/unstake-page";
import { assetRouteLoader } from "../../features/staking/utils/route-loaders";

export const Route = createFileRoute("/_layout/staking/$asset/unstake")({
  loader: assetRouteLoader,
  component: UnstakePage,
  staticData: {
    layout: {
      showNavigationTabs: false,
    },
  },
});
